import { render, staticRenderFns } from "./StructuredData.vue?vue&type=template&id=d7f16368&scoped=true&"
import script from "./StructuredData.vue?vue&type=script&lang=js&"
export * from "./StructuredData.vue?vue&type=script&lang=js&"
import style0 from "./StructuredData.vue?vue&type=style&index=0&id=d7f16368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f16368",
  null
  
)

component.options.__file = "StructuredData.vue"
export default component.exports